import { Id } from '@vimeo/core/types/generic';

import { TConnectionSupportedMethodParams, withConnectionSupport } from './base';
import { ERequestMethod } from '../types/api';
import { ILiveComposerApplicationConfig, IStreamHealthCredentials } from '../types/broadcaster';
import { TComposerSessionCode } from '../types/composer_session';
import {
  IGuestInteractionApplicationConfig,
  IInteractionApplicationConfig,
} from '../types/interaction_tools';

/**
 * Get interaction configuration for firebase application.
 * Uses generic method that relies on security checks based on vimeo token.
 * First of all, it checks ownership and then tries to enforce event-based privacy (hash, password etc).
 *
 * todo: Proper JSDoc
 */
export function getInteractionConfig(
  params: TConnectionSupportedMethodParams<{ roomId: Id }>,
): Promise<IInteractionApplicationConfig> {
  return withConnectionSupport(ERequestMethod.GET, params, ({ roomId }) => ({
    path: `/live_chat/${roomId}/config`,
  }));
}

/**
 * Get interaction configuration for firebase application guest.
 * Uses code as main source of auth verification without fallback to event based privacy.
 * Lacks all information related to embed/interaction tools etc since it is not needed in any way here.
 *
 * todo: Proper JSDoc
 */
export function getGuestInteractionConfig(
  params: TConnectionSupportedMethodParams<{
    liveEventId: Id;
    code: TComposerSessionCode;
  }>,
): Promise<IGuestInteractionApplicationConfig> {
  return withConnectionSupport(ERequestMethod.GET, params, ({ liveEventId, code }) => ({
    path: `/live_events/${liveEventId}/guest/chat`,
    query: { code: code },
  }));
}

/**
 * Get broadcaster composer configuration for firebase application.
 * todo: Proper JSDoc
 */
export function getBroadcasterComposerConfig(
  params: TConnectionSupportedMethodParams<{ liveEventId: Id }>,
): Promise<ILiveComposerApplicationConfig> {
  return withConnectionSupport(ERequestMethod.GET, params, ({ liveEventId }) => ({
    path: `/live_events/${liveEventId}/broadcaster/composer`,
  }));
}

/**
 * Get guest composer configuration for firebase application.
 * todo: Proper JSDoc
 */
export function getGuestComposerConfig(
  params: TConnectionSupportedMethodParams<{
    liveEventId: Id;
    code: TComposerSessionCode;
  }>,
): Promise<ILiveComposerApplicationConfig> {
  return withConnectionSupport(ERequestMethod.GET, params, ({ liveEventId, code }) => ({
    path: `/live_events/${liveEventId}/guest/composer`,
    query: { code: code },
  }));
}

/**
 * todo: Proper JSDoc
 */
export function getStreamHealthCredentials(
  params: TConnectionSupportedMethodParams<{
    liveEventId: Id;
  }>,
): Promise<IStreamHealthCredentials> {
  return withConnectionSupport(ERequestMethod.GET, params, ({ liveEventId }) => ({
    path: `/live_events/${liveEventId}/stream_health`,
  }));
}
